/* eslint-disable no-alert */
import React from 'react'
import moment from 'moment'
import firebase from 'firebase/app'
import { Label, Popup, Table, Button } from 'semantic-ui-react'
import get from 'lodash/get'

import StatusButton from './ActionButtons/Status'
import CancelButton from './ActionButtons/Cancel'
import ConfirmButton from './ActionButtons/Confirm'
import ReOrderButton from './ActionButtons/ReOrder'
import PackageSize from './ActionButtons/PackageSize'
import SwitchOperator from './ActionButtons/SwitchOperator'

import RequestCloseStoreForm from './RequestCloseStoreForm'

export default class ActionsCell extends React.PureComponent {
  state = {
    confirmingPackage: false,
    confirmingDriver: false,
    closeFormVisible: false,
    temporaryClosed: null,
  }

  setLoading = (field, value) => this.setState({ [field]: value })

  onRequestClose = () => this.setState({ closeFormVisible: false })

  onRequestCloseClick = async () => {
    const { order } = this.props

    const merchantId = get(order, 'restaurant.key', '')
    const branchId = get(order, 'restaurant.branch.key', '')

    const isRequestExist = await this.isRequestExist(merchantId, branchId)
    const { isClose, temporaryClosed } = await this.isStoreClosed(merchantId, branchId)

    if (isRequestExist) {
      alert(`Request is under Review.`)
    } else if (isClose) {
      const startedAt = moment(temporaryClosed.start_at).format('DD/MM/YYYY')
      const endedAt = moment(temporaryClosed.end_at).format('DD/MM/YYYY')

      const confirmation = window.confirm(
        `Store is already close from ${startedAt} till ${endedAt}, still continue?`
      )
      if (confirmation) {
        this.setState({ closeFormVisible: true, temporaryClosed })
      }
    } else {
      this.setState({ closeFormVisible: true })
    }
  }

  isRequestExist = async (merchantId, branchId) => {
    const snapshot = await firebase
      .firestore()
      .collection('merchant_close_requests')
      .where('merchant_id', '==', merchantId)
      .where('branch_id', '==', branchId)
      .where('status', '==', 'pending')
      .get()

    return snapshot.size > 0
  }

  isStoreClosed = async (merchantId, branchId) => {
    const now = Number(moment().format('x'))
    const snapshot = await firebase
      .database()
      .ref(`restaurants/${merchantId}/branches/${branchId}/temporary_closed`)
      .once('value')

    const branchTempClosed = snapshot.val()

    let isClose = false
    let temporaryClosed = null

    if (branchTempClosed && branchTempClosed.end_at >= now) {
      isClose = true
      temporaryClosed = branchTempClosed
    }

    return { isClose, temporaryClosed }
  }

  onSendReportClick = () => {
    const { order, operator } = this.props

    let merchantName = order.restaurant.name
    const date = moment().format('YYYY-MM-DD')
    const orderId = order.key
    const { username = '' } = operator

    merchantName = merchantName.replace('&', ' and ')

    const googleFormUrl = encodeURI(
      `https://docs.google.com/forms/d/e/1FAIpQLSfMA29IHkLB_gspYlS9pJpU9PO2bJX0T68pcAvi2B_zTVMwEg/viewform?usp=pp_url&entry.2015060946=${merchantName}&entry.210153954=${date}&entry.160255726=${orderId}&entry.742412119=${username}`
    )

    window.open(googleFormUrl)
  }

  getLatency = () => {
    const { order } = this.props

    const startAt = moment(Number(order.created_at, 10))
    const updateAt = moment(Number(order.updated_at, 10))

    const duration = moment.duration(updateAt.diff(startAt)).as('minutes')

    const remaining = parseInt(order.order_took_eta - duration, 10)

    return remaining
  }

  renderLatency = () => {
    const { order } = this.props
    const latency = this.getLatency()

    return (
      <div key="latency">
        <Label style={{ width: 150, margin: 0, marginTop: 5 }}>ETA: {order.order_took_eta} minutes</Label>
        <Label color={latency < 0 ? 'red' : 'green'} style={{ width: 150, margin: 0, marginTop: 5 }}>
          Latency: {latency} minutes
        </Label>
      </div>
    )
  }

  renderScheduled = () => {
    const { order } = this.props

    if (order.delivery_time !== undefined && order.delivery_time !== 'ETA') {
      const scheduled = moment(order.delivery_time)
      const shouldOrder = scheduled.subtract(parseInt(order.order_took_eta, 10), 'minutes')

      return (
        <Popup
          wide
          on="click"
          hideOnScroll
          key="scheduled"
          position="top center"
          trigger={<Label style={{ marginTop: 5, width: 150 }}>Schedule</Label>}
        >
          <div style={{ textAlign: 'center' }}>
            <div>
              Scheduled at <Label>{moment(order.delivery_time).format('hh:mm a')}</Label>
            </div>

            <div style={{ marginTop: 5 }}>
              Should order at <Label>{shouldOrder.format('hh:mm a')}</Label>
            </div>
          </div>
        </Popup>
      )
    }

    return null
  }

  renderRegion = () => {
    const { region } = this.props
    const isREP = region && region.id === 'rep'

    return (
      <Label
        {...(isREP ? { color: 'orange' } : {})}
        style={{ height: 31, display: 'flex', alignItems: 'center' }}
      >
        {region ? region.code : 'PNH'}
      </Label>
    )
  }

  renderOpt = () => {
    const { order, operators } = this.props
    const currentOperator = operators[order.current_operator]

    return (
      <React.Fragment key={order.key}>
        <Label style={{ width: 150, margin: 0, marginTop: 5 }}>
          Opt: {currentOperator && currentOperator.username}
        </Label>
      </React.Fragment>
    )
  }

  renderRequestCloseStoreButton = () => {
    const { order, operator } = this.props
    const { closeFormVisible, temporaryClosed } = this.state

    return (
      <React.Fragment>
        <div style={{ position: 'absolute', top: 5, right: 92, textAlign: 'center', marginBottom: 5 }}>
          <Button
            icon="close"
            order={order}
            color="orange"
            operator={operator}
            style={{ padding: 8 }}
            onClick={this.onRequestCloseClick}
          />
        </div>

        {closeFormVisible ?
          <RequestCloseStoreForm
            order={order}
            operator={operator}
            visible={closeFormVisible}
            onClose={this.onRequestClose}
            temporaryClosed={temporaryClosed}
          />
        : null}
      </React.Fragment>
    )
  }

  render() {
    const {
      order,
      showModalPackage,
      showCancelReasons,
      readOnly,
      readyToPickUp,
      operator,
      operators,
    } = this.props
    const { confirmingPackage, confirmingDriver } = this.state
    const actions = []

    switch (order.status) {
      case 'pending': {
        const buttonProps = {
          order,
          readOnly,
          readyToPickUp,
          confirmingDriver,
          showModalPackage,
          showCancelReasons,
          confirmingPackage,
          setLoading: this.setLoading,
        }

        actions.push(<ConfirmButton {...buttonProps} key="confirm" />)
        actions.push(<CancelButton {...buttonProps} key="cancel" />)
        break
      }
      case 'confirmed':
      case 'drivers_not_available':
      case 'outForDelivery': {
        const buttonProps = { order, readOnly, showCancelReasons }

        actions.push(<StatusButton {...buttonProps} key="status" />)
        actions.push(<PackageSize {...buttonProps} key="size" />)
        actions.push(<CancelButton {...buttonProps} key="cancel" />)
        break
      }
      case 'rejected': {
        const buttonProps = { order, readOnly: true }

        actions.push(<StatusButton {...buttonProps} key="status" />)
        actions.push(<PackageSize {...buttonProps} key="size" />)
        actions.push(<ReOrderButton {...buttonProps} key="reorder" />)
        break
      }
      case 'delivered': {
        const buttonProps = { order, readOnly: true }

        actions.push(<StatusButton {...buttonProps} key="status" />)
        actions.push(<PackageSize {...buttonProps} key="size" />)
        actions.push(this.renderLatency())
        actions.push(this.renderScheduled())
        break
      }
      default:
        break
    }

    actions.push(this.renderOpt())

    return (
      <Table.Cell textAlign="center" style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', top: 5, right: 5, textAlign: 'center', marginBottom: 5 }}>
          <Button icon="file" color="orange" size="tiny" onClick={this.onSendReportClick} basic />
        </div>

        <div style={{ position: 'absolute', top: 5, right: 45, textAlign: 'right', marginBottom: 5 }}>{this.renderRegion()}</div>
        {Object.values(order.operators || {}).length > 0 && (
          <div style={{ position: 'absolute', top: 5, right: 130, textAlign: 'center', marginBottom: 5 }}>
            <SwitchOperator order={order} operator={operator} operators={operators} readOnly={readOnly} />
          </div>
        )}

        {this.renderRequestCloseStoreButton()}

        <div style={{ padding: '35px 0px' }}>{actions}</div>
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionsCell.js